import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ReadingViewModeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { EditorDoingTest } from '../components/EditorDoingTest/EditorDoingTest';
import { DoTestReadingMobileLayout } from '../layouts/DoTestReadingMobileLayout';
import { ReadingTestLayout } from '../layouts/ReadingTestLayout';
import { ReadingTestSubmissionProps } from '../layouts/ReadingTestSubmission';
import { QuestionContentMobile } from '../mobile/Question/QuestionContentMobile';
import { useTestSubmissionStore } from '../model/test-submissions.hook';

export const ReadingTestSubmissionTablet = observer((props: ReadingTestSubmissionProps) => {
  const { onSubmitWithEvents, onQuit } = props;
  const testSubmissionStore = useTestSubmissionStore();
  const currentSection = testSubmissionStore.currentTestSection;
  const { currentViewMode } = currentSection;

  const switchToPassageView = () => {
    if (currentViewMode === ReadingViewModeEnum.QUESTION) {
      toggleViewMode();
      currentSection.updateCurrentViewMode(ReadingViewModeEnum.QUESTION);
    }
  };

  const toggleViewMode = () => {
    currentSection.updateCurrentViewMode(
      currentViewMode === ReadingViewModeEnum.PASSAGE
        ? ReadingViewModeEnum.QUESTION
        : ReadingViewModeEnum.PASSAGE
    );
  };

  return (
    <DoTestReadingMobileLayout
      onQuit={onQuit}
      onSubmitWithEvents={onSubmitWithEvents}
      onToggleViewMode={toggleViewMode}
    >
      <DoTestContentWrapper>
        <div className="content-wrapper">
          <EditorDoingTest
            key={currentSection?.id}
            initialValue={currentSection?.getPassage()}
            selectionOnly
            withToolBar
            id="passage-container"
          />
          <QuestionContentMobile
            id="body-container"
            onNavigation={switchToPassageView}
            onSubmit={onSubmitWithEvents}
          />
        </div>
      </DoTestContentWrapper>
    </DoTestReadingMobileLayout>
  );
});

const DoTestContentWrapper = styled(ReadingTestLayout)`
  min-height: calc(100vh - 126px);

  .content {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px 24px;
    height: 100%;
  }
  .buttons {
    margin-top: 8px;
  }

  .header-container > section,
  .dol-question {
    border-radius: 16px;
  }

  #passage-container {
    background-color: ${colorsV2.white100};
    position: relative;
    overflow: auto;
    padding: 0;
  }
  #body-container {
    padding: 16px 24px;
    .question-group {
      box-shadow: unset;
      div {
        box-shadow: unset;
      }
    }
    .dol-question {
      margin-top: 16px;
    }
    .buttons {
      padding: 0;
    }
  }

  #passage-container,
  #body-container {
    max-height: calc(100vh - 120px);
    min-height: calc(100vh - 120px);
    display: block;
  }
`;
